import { useEmblaCarousel } from 'embla-carousel/react';
import React, { ReactNode, useCallback, useEffect, useState } from 'react';
import { css } from 'styled-components';
import useRecursiveTimeout from '@insite/client-framework/Common/Hooks/useRecursiveTimeout';
import StyledWrapper from '@insite/client-framework/Common/StyledWrapper';
import Button, { ButtonIcon } from '@insite/mobius/Button';
import BannerArrow from '@NA/Icons/BannerArrow';
import { BannerCarouselList } from '@NA/Services/GetBannerCarousel';
import ADIColors from '@NA/Utils/ADIColors';
import { VisualFilter } from '@NA/Services/GetVisualCarousal';
import Hidden from '@insite/mobius/Hidden';

const EmblaCarouselWrappeForVisNav = ({
    fields,
    styles,
    carouselList,
    children,
    isMobile,
    isTablet
}: {
    fields: any;
    styles: any;
    carouselList: VisualFilter[];
    children: ReactNode;
    isMobile: any;
    isTablet: any;
}) => {
    const [emblaRef, embla] = useEmblaCarousel();
    const [selectedIndex, setSelectedIndex] = useState(0);

    const scrollNext = useCallback(() => {
        if (!embla) return;
        embla.scrollNext();
    }, [embla]);

    const moveNextScroll = useCallback(() => {
        if (!embla) return;
        if (carouselList.length > 6) {
            setSelectedIndex(1)
            const move = carouselList.length - 6;
            embla.scrollTo(Number(move))
        }
    }, [embla]);

    const movePrevScroll = useCallback(() => {
        if (!embla) return;
        setSelectedIndex(0)
        embla.scrollTo(0)
    }, [embla]);

    useRecursiveTimeout(scrollNext, fields.autoplay * 1000);

    useEffect(() => {
        if (!embla || !carouselList || carouselList.length === 0) return;

        embla.reInit({
            align: "start",
            loop: false,
            draggable: (isMobile || isTablet) ? true :false
        });
    }, [embla, carouselList]);

    return (
        <StyledWrapper {...styles.emblaWapperTopContainer}>
            {fields.showArrows && carouselList.length > 6 && (
                <StyledWrapper {...styles.arrowWrapper}>
                    <Button {...(selectedIndex == 0 ?styles.prevArrowButtonDisable: styles.prevArrowButton)}
                    onClick={() => movePrevScroll()}/>
                </StyledWrapper>
            )}
           
            <StyledWrapper style = {{overflow: "hidden", width: "100%"}} ref={emblaRef}>
                {children}
            </StyledWrapper>
           
            {fields.showArrows && carouselList.length > 6 && (
                 
                <StyledWrapper {...styles.arrowWrapper}>
                    <Button  {...(selectedIndex == 0 ?styles.nextArrowButton: styles.nextArrowButtonDisable)}
                    onClick={() => moveNextScroll()}/>
                </StyledWrapper>
            )}
           
        </StyledWrapper>
    );
};

export default EmblaCarouselWrappeForVisNav;